import React from 'react';
import {useIntl} from 'react-intl';
import {HiOutlineArrowLeft} from '@react-icons/all-files/hi/HiOutlineArrowLeft';
import './backButton.less';

export default function BackButton({onClick, label = '', dataWdio = ''}) {
    const intl = useIntl();
    const text = label || intl.formatMessage({id: 'esl.generic.back', defaultMessage: 'Back'});

    return (
        <button
            type="button"
            className="back-button"
            onClick={onClick}
            data-wdio={dataWdio}
        >
            <HiOutlineArrowLeft className="back-button-icon" />
            <span>{text}</span>
        </button>
    );
}
